import Cookie from 'js-cookie';

export const setSameSiteCookie = (key, value, extra = {}) => {
  if (extra && window.top !== window.self) {
    extra.samesite = 'none';
    extra.secure = true;
    Cookie.set(key, value, extra);
  } else Cookie.set(key, value, extra);
};
